import React from 'react';

import { Grid } from '@gogame/components';
import { SidePageV2, FormField, withForm } from '@gogame/form';

import { tagsCategorySchema } from './schemas';

const CategoryForm = withForm({
  validationSchema: tagsCategorySchema,
})(({ loading, title, onExited, onClose, open }) => {
  return (
    <SidePageV2
      open={open}
      onExited={onExited}
      onClose={onClose}
      size={'md'}
      loading={loading}
    >
      <SidePageV2.Title title={title} />
      <SidePageV2.Content>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <FormField.TextField
              name={'name'}
              label={'Name'}
              required={true}
              variant={'outlined'}
              padding={'0'}
            />
          </Grid>
          <Grid item xs={12}>
            <FormField.ChipsInput
              name={'tags'}
              label={'Tags'}
              required={true}
              freeSolo={true}
              padding={'0'}
            />
          </Grid>
        </Grid>
      </SidePageV2.Content>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
    </SidePageV2>
  );
});

export default CategoryForm;
